module.exports = __webpack_public_path__ + "img/howto_img_11.13d40ee0.jpg";